import i18n from "translation/i18n";

export const ShowDocument = ({ document }) => (
  <div className="d-flex align-items-center mb-3">
    <i className="document-icon fas fa-file-alt fa-2x mr-3" />
    <a href={document.fileUrl} target="blank">
      {i18n.language === 'en' ? document.name : document.nameKh}
    </a>
  </div>
);